<template>
  <div>
    <div class="mb-3">
      <label for="document" class="form-label"> Documento del Usuario </label>
      <input
        type="text"
        class="form-control"
        id="document"
        v-model="localForm.document"
        placeholder="Ingrese el documento"
        required
      />
    </div>

    <div class="mb-3">
      <label for="userType" class="form-label">Tipo de Usuario</label>
      <select
        class="form-select"
        id="userType"
        v-model="localForm.userType"
        required
      >
        <option value="">Seleccione...</option>
        <option value="ESTUDIANTE">Estudiante</option>
        <option value="MAESTRO">Maestro</option>
        <option value="PUBLICO">Público General</option>
      </select>
    </div>

    <div class="mb-3" v-if="localForm.document && localForm.userType">
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="verifyUser"
        :disabled="verifying"
      >
        {{ verifying ? "Verificando..." : "Verificar Usuario" }}
      </button>
    </div>

    <div v-if="userData" class="mb-3">
      <h6>Información del Usuario:</h6>
      <p><strong>Nombre:</strong> {{ userData.name }}</p>
      <p><strong>Documento:</strong> {{ userData.username }}</p>
      <p>
        <strong>Contraseña por defecto cambiada?:</strong>
        {{ userData.need_change_pass ? "No" : "Sí" }}
      </p>
      <p>
        <strong>Sesion abierta?:</strong>
        {{ userData.is_logged ? "Sí" : "No" }}
      </p>
    </div>

    <div v-if="!userData && searchAttempted" class="alert">
      No se encontró un usuario con ese documento y tipo de usuario.
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";

const props = defineProps({
  formData: Object,
});

const emit = defineEmits(["dataVerified"]);

const verifying = ref(false);
const userData = ref(null);
const searchAttempted = ref(false);

const localForm = ref({
  document: "",
  userType: "",
});

async function verifyUser() {
  if (!localForm.value.document || !localForm.value.userType) {
    toast.warning("Complete documento y tipo de usuario");
    return;
  }

  verifying.value = true;
  searchAttempted.value = true;

  try {
    const response = await axios.post("/clie/verify-by-document", {
      document: localForm.value.document,
      user_type: localForm.value.userType,
    });

    if (response.data) {
      userData.value = response.data;
      toast.success("Usuario encontrado");

      emit("dataVerified", {
        participant_document: localForm.value.document,
        user_type: localForm.value.userType,
        detail: `Solicitud de restablecimiento de contraseña para ${response.data.name} (${localForm.value.document}) - ${localForm.value.userType}`,
      });
    }
  } catch (error) {
    console.error("Error", error);
    toast.error("Usuario no encontrado");
    userData.value = null;
  } finally {
    verifying.value = false;
  }
}
</script>
